module.exports = __webpack_public_path__ + "static/027-780b275497d9a11406c621ef68019c53.jpg";